import { 
  ChangeEmailModel, 
} from './change-email.model';

import {
  BaseClass,
  dropProps,
} from 'src/api/models/Base/base.class';

import { InputModel } from 'src/api/models/Form/InputField/input.model';

import { InputClass } from 'src/api/models/Form/InputField/input.class';

import { changeEmailFormData } from './change-email.data';

export class ChangeEmailClass extends BaseClass<ChangeEmailModel> implements ChangeEmailModel {
  get email(): InputModel {
    return dropProps(this.props.email, new InputClass(this.props.email)); 
  }
  
}

export const changeEmailFormValues = () => changeEmailFormData && dropProps(changeEmailFormData(), new ChangeEmailClass(changeEmailFormData()));
